enum ActionType {
    SET_FILTER_STATE = '[CORE/CHRFILTER] SET FILTER TOGGLE STATE',
}

export default ActionType
